module.exports = __webpack_public_path__ + "img/gn.cc944c9e.svg";